import React, { useState, useEffect } from "react";
import { styled } from "@glitz/react";
import { Image } from "../types";
import { spacing } from "../theme";

interface ImageGalleryProps {
  images: Image[];
  showThumbnail: boolean;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  showThumbnail,
}) => {
  const [chosenImage, setChosenImage] = useState<Image | null>(null);

  useEffect(() => {
    if (images.length > 0) {
      setChosenImage(images[0]);
    }
  }, [images]);

  const handleThumbnailClick = (image: Image) => {
    setChosenImage(image);
  };

  return (
    <ImageGalleryWrapper>
      {showThumbnail && (
        <ThumbnailGallery>
          {images.map((image, index) => (
            <Thumbnail
              key={`${image.id}-${index}`}
              src={image.src}
              alt={image.alt}
              className="thumbnail"
              loading="lazy"
              decoding="async"
              onClick={() => handleThumbnailClick(image)}
            />
          ))}
        </ThumbnailGallery>
      )}
      {chosenImage && (
        <ImgWrapper>
          <Img
            src={chosenImage.src}
            alt={chosenImage.alt}
            loading="lazy"
            decoding="async"
          />
        </ImgWrapper>
      )}
    </ImageGalleryWrapper>
  );
};

const ImageGalleryWrapper = styled.div({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});

const ImgWrapper = styled.div({
  width: "450px",
  maxWidth: "100%",
  height: "auto",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  marginLeft: spacing.xs,
});

const Img = styled.img({
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

const ThumbnailGallery = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.xs,
});

const Thumbnail = styled.img({
  width: "50px",
  height: "auto",
  cursor: "pointer",
  transitionProperty: "transform",
  transitionDuration: "0.2s",
  transitionTimingFunction: "ease",
  ":hover": {
    transform: "scale(1.1)",
  },
});

export default ImageGallery;
